export default "__VITE_ASSET__DXLmyAJz__"